<template>
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.1212 17.9012C13.504 17.2622 13.8193 16.1466 13.8867 15.5025C14.0122 13.9215 13.951 12.517 13.504 10.989C13.4143 10.7125 13.3148 10.4366 13.2032 10.165C12.3087 10.956 11.2385 11.7393 9.96398 12.5718C8.7137 11.7551 7.65998 10.9858 6.77595 10.21C6.67176 10.4671 6.57826 10.7278 6.49359 10.989C6.04653 12.517 5.9853 13.9215 6.11085 15.5025C6.17821 16.1466 6.49359 17.2622 6.87637 17.9012C4.01179 17.0331 1.96538 15.1964 0.832031 12.363C1.94026 13.9492 4.28599 13.8285 4.29092 10.4052C4.29293 9.00576 4.49687 7.42907 5.0307 5.96323L5.06367 5.79644C5.06908 5.80787 5.07452 5.81929 5.07998 5.83072C5.88457 3.71151 7.39345 1.8446 9.99892 1.11328C12.5665 1.83397 14.0691 3.65748 14.8821 5.73847C14.8886 5.72457 14.895 5.71068 14.9014 5.69678L14.9467 5.90818C15.4956 7.38952 15.7046 8.98822 15.7066 10.4052C15.7116 13.8285 18.0573 13.9492 19.1655 12.363C18.0322 15.1964 15.9858 17.0331 13.1212 17.9012ZM12.5806 8.93448C12.3133 8.5058 11.9998 8.10819 11.629 7.76154C11.1717 7.36959 10.6164 7.04704 9.99892 7.03377C9.3814 7.04704 8.82584 7.36959 8.36856 7.76154C7.98557 8.11953 7.66378 8.53187 7.39086 8.97665C8.10164 9.63292 8.95119 10.2311 9.96398 10.7334C10.9984 10.2204 11.8619 9.6073 12.5806 8.93448Z"
            fill="#666666"
        />
    </svg>
</template>
<script>
export default {
    data() {
        return {};
    },
};
</script>
